import { useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'
import { NavigationEvents } from '@mc/track-event'
import Link from 'components/Link'
import { trackGiftCTAClick } from 'components/Navigation/events'

export const GiftsLink = () => {
  const { t } = useTranslation('@mc/next')

  return (
    <Link
      className='d-none d-lg-block mc-ml-4'
      href={paths.gift}
      onClick={() => trackGiftCTAClick(NavigationEvents.LEVELS.SECONDARY)}
    >
      {t('nav.cta.gift')}
    </Link>
  )
}
